import { AimOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { CSSProperties, useContext } from 'react';
import { transform as transformCoords } from 'ol/proj';
import MapViewContext from '../../../../../../../../../../contexts/MapViewContext';
import { initialCenter, initialZoom } from '../../../../../../../../../../configs/initialValues';

interface GoCenterButtonProps {
  style?: CSSProperties
}

function GoCenterButton({ style }: GoCenterButtonProps) {
  const { map } = useContext(MapViewContext);

  return (
    <Button
      style={style}
      icon={<AimOutlined />}
      onClick={() => {
        const view = map?.getView();
        if (view) {
          view.setCenter(transformCoords(initialCenter, 'EPSG:4326', 'EPSG:3857'));
          view.setZoom(initialZoom);
        }
      }}
    />
  );
}

export default GoCenterButton;
